export const shipCompanyList = {
  shunfeng: '顺丰快递',
  zhongtong: '中通快递',
  youzheng: '邮政快递',
  yunda: '韵达快递',
  yuantong: '圆通快递',
  shentong: '申通快递',
  debang: '德邦快递',
  jitu: '极兔快递',
  EMS: 'EMS'
}

export const blankPic = 'data:img/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEXs7Oxc9QatAAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg=='
export const anonymousUserPic = 'https://img.xinshu.me/resource/ac6769c1fadb454c9c79d72c18291c23'
export const providerList = {
  yc: '易材',
  gs: '广森',
  kunlun: '昆仑',
  yinjie: '印捷',
  gy: '广盈',
  xinshu: '电子版'
}

export const orderStatusList = {
  0: '未付款',
  1: '已付款',
  2: '印刷中',
  3: '已发货',
  5: '已退款'
}

export const printStatusList = {
  0: '未打印',
  1: '排队中',
  2: '下载中',
  3: '导出中',
  5: 'PDF',
  8: '分册错误',
  9: '打印错误'
}

export const bindingList = {
  0: '经济装',
  1: '文艺装',
  2: '精装',
  pdf: '电子版'
}
